import { useIsRegisteredForEInvoicing } from '@features/attachments/hooks/useIsRegisteredForEInvoicing'
import { useEInvoicingSetup as usePDPSetup } from '@features/eInvoicing/hooks/useEInvoicingSetup'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { EInvoicingNetworks } from '../constants/EInvoicingNetworks'
import { NemHandelNetworkConfig, PDPNetworkConfig } from '../types'

export type UseEInvoicingSetupsResult = {
  [EInvoicingNetworks.PDP]: PDPNetworkConfig | null
  [EInvoicingNetworks.NEMHANDEL]: NemHandelNetworkConfig | null
}

/**
 * Gets all possible e-invoicing settings from different networks
 * and returns a map of configuration options.
 * Any consumer is expected to understand these types
 */
export const useEInvoicingSetups = (): UseEInvoicingSetupsResult => {
  const pdpSetup = usePDPSetup()
  const { organization, isLoading: isOrganizationLoading } = useUserOrganization()

  const { isRegistered, isLoading: isRegistrationLoading, activationDate } = useIsRegisteredForEInvoicing()

  const isDanishOrganization = organization?.countryId === 'DK'

  return {
    [EInvoicingNetworks.PDP]:
      !isDanishOrganization && pdpSetup
        ? {
            networkType: EInvoicingNetworks.PDP,
            isLoading: pdpSetup.loading,
            actions: {
              activate: pdpSetup.eInvoiceIntegration?.status !== 'ACTIVE',
              // This will likely need to change after the
              // network-status project from Shine PA
              deactivate: pdpSetup.eInvoiceIntegration?.status === 'ACTIVE',
            },
            config: pdpSetup,
          }
        : null,

    [EInvoicingNetworks.NEMHANDEL]: isDanishOrganization
      ? {
          networkType: EInvoicingNetworks.NEMHANDEL,
          isLoading: isOrganizationLoading || isRegistrationLoading,
          actions: {
            activate: !isRegistered,
            deactivate: isRegistered,
          },
          config: {
            isRegistered,
            cvr: organization?.registrationNo ?? '',
            activationDate,
          },
        }
      : null,
  }
}
